import {
	Box,
	HStack,
	VStack,
	Text,
	Avatar,
	IconButton,
	Tooltip,
	useDisclosure,
} from '@chakra-ui/react';
import { RiLogoutBoxRFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../../redux/reducers/AuthReducer';
import { useNavigate } from 'react-router-dom';
import { FormModalEditProfile } from '../modal/FormModalEditProfile';
import { formatedLastName } from '../../../../utils/FormatedLastName';
import { useTranslation } from 'react-i18next';

export const FinalItem = () => {
	const dispatch = useDispatch();
	const { user } = useSelector((state: any) => state.auth || {});
	const navigate = useNavigate();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const { t } = useTranslation();

	const handleLogout = () => {
		(dispatch as any)(logout()).then(() => {
			localStorage.removeItem('selectedCenter');
			navigate('/');
			window.location.reload();
		});
	};

	const canEditProfile = !['cuidadora', 'fisio', 'limpiadora', 'auxiliar', 'enfermera', 'medico'].includes(user?.role);
	const displayName = `${user?.name || ''} ${formatedLastName(user?.lastname) || ''}`.trim() || t('Usuario');
	const displayRole = user?.isAdmin
		? 'SuperAdmin'
		: user?.role
		? user.role.charAt(0).toUpperCase() + user.role.slice(1)
		: 'Supervisión Médica';

	return (
		<>
			<HStack
				w="full"
				p={2}
				bg="whiteAlpha.100"
				borderRadius="xl"
				border="1px solid"
				borderColor="whiteAlpha.100"
				justify="space-between"
				align="center"
			>
				{/* Avatar + Nombre + Rol */}
				<HStack spacing={2.5} overflow="hidden" flex="1">
					<Avatar
						size="sm"
						name={displayName}
						bg="teal.500"
						color="white"
						boxShadow="sm"
					/>
					<VStack align="flex-start" spacing={0} overflow="hidden">
						<Text
							fontSize="13px"
							fontWeight="semibold"
							color="white"
							lineHeight="1.2"
							isTruncated
							maxW="110px"
						>
							{displayName}
						</Text>
						<Text
							fontSize="11px"
							color="teal.300"
							fontFamily="mono"
							lineHeight="1.2"
							isTruncated
							maxW="110px"
						>
							{displayRole}
						</Text>
					</VStack>
				</HStack>

				{/* Botones de acción rápida */}
				<HStack spacing={1}>
					{canEditProfile && (
						<Tooltip label={t('Edit profile') || 'Editar perfil'} placement="top" hasArrow>
							<IconButton
								aria-label={t('Edit profile') || 'Editar perfil'}
								icon={<FaEdit />}
								size="xs"
								variant="ghost"
								color="gray.400"
								_hover={{ color: 'teal.300', bg: 'whiteAlpha.200' }}
								onClick={onOpen}
							/>
						</Tooltip>
					)}
					<Tooltip label={t('Logout') || 'Cerrar sesión'} placement="top" hasArrow>
						<IconButton
							aria-label={t('Logout') || 'Cerrar sesión'}
							icon={<RiLogoutBoxRFill />}
							size="xs"
							variant="ghost"
							color="gray.400"
							_hover={{ color: 'red.300', bg: 'whiteAlpha.200' }}
							onClick={handleLogout}
						/>
					</Tooltip>
				</HStack>
			</HStack>

			<FormModalEditProfile
				isOpen={isOpen}
				onClose={onClose}
				userData={user}
			/>
		</>
	);
};
